import { getPayTypeList, getPayAgreedList, getExpressDeliveryList } from '@/api/commons'
import CONST from '@/utils/const'
import * as Utils from '@/utils/index'

const state = {
  payTypeList: [], // 支付方式（销售单）
  payTypeOfCompanyList: [], // 支付方式（付款单）
  payAgreedList: [], // 支付约定
  expressDeliveryList: [] // 配送方式
}

const mutations = {
  initPayTypeList: (state, payTypeList, payTypeOfCompanyList) => {
    state.payTypeList = payTypeList
    state.payTypeOfCompanyList = payTypeOfCompanyList
  },
  initPayAgreedList: (state, payAgreedList) => {
    state.payAgreedList = payAgreedList
  },
  initExpressDeliveryList: (state, expressDeliveryList) => {
    state.expressDeliveryList = expressDeliveryList
  }
}

const actions = {
  initPayTypeList({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getPayTypeList({
        page: CONST.PAGINATION.PAGE,
        rows: CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'asc',
        status: CONST.STATUS.find(type => type.name === '启用').id
      }).then(resp => {
        const payTypeAllList = resp.rows || []
        const payTypeList = payTypeAllList.filter(payType => payType.type === 1)
        const payTypeOfCompanyList = payTypeAllList.filter(payType => payType.type !== 1)
        commit('initPayTypeList', payTypeList, payTypeOfCompanyList)
        dispatch('tip/add', {key: Utils.createUniqueString(), name: '初始化支付方式成功.'}, {root: true})
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  initPayAgreedList({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getPayAgreedList({
        page: CONST.PAGINATION.PAGE,
        rows: CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'asc',
        status: CONST.STATUS.find(type => type.name === '启用').id
      }).then(resp => {
        const payAgreedList = resp.rows || []
        commit('initPayAgreedList', payAgreedList)
        dispatch('tip/add', { key: Utils.createUniqueString(), name: '初始化支付约定成功.' }, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  initExpressDeliveryList({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getExpressDeliveryList({
        page: CONST.PAGINATION.PAGE,
        rows: CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'asc',
        status: CONST.STATUS.find(type => type.name === '启用').id
      }).then(resp => {
        const expressDeliveryList = resp.rows || []
        commit('initExpressDeliveryList', expressDeliveryList)
        dispatch('tip/add', { key: Utils.createUniqueString(), name: '初始化配送方式成功.' }, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dict.js